module.exports = __webpack_public_path__ + "img/IMD_SFJ_030.e17e2c63.jpg";